export const unauthenticatedHelper = (error = {}) => {
  const message = String(error.message || '');
  return message.match(/unauthenticated/i);
};
